"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISerializedNetAnnotationsSchema = void 0;
const zod_1 = require("zod");
const INetAnnotation_1 = require("./INetAnnotation");
exports.ISerializedNetAnnotationsSchema = zod_1.default.object({
    annotations: zod_1.default.record(zod_1.default.string(), zod_1.default.record(zod_1.default.string(), zod_1.default.array(INetAnnotation_1.INetAnnotationSchema))),
});
//# sourceMappingURL=ISerializedNetAnnotations.js.map